<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12.5 3.333V7.5m0 0h4.166m-4.166 0 5-5m-8.978 9.053A12.17 12.17 0 0 1 6.15 8.21a1.415 1.415 0 0 1-.094-.222.872.872 0 0 1 .123-.718c.04-.056.087-.103.183-.199.29-.29.437-.437.532-.583.359-.552.359-1.265 0-1.817-.095-.146-.241-.292-.532-.583l-.163-.163c-.443-.443-.664-.664-.902-.784a1.667 1.667 0 0 0-1.504 0c-.238.12-.46.341-.903.784l-.13.132c-.442.44-.663.662-.831.962-.188.332-.322.85-.32 1.231 0 .345.067.58.2 1.05a15.866 15.866 0 0 0 4.062 6.903 15.865 15.865 0 0 0 6.903 4.061c.47.134.705.2 1.05.202.381 0 .898-.134 1.231-.32.3-.17.521-.39.962-.831l.132-.132c.443-.443.664-.664.784-.902.24-.473.24-1.031 0-1.504-.12-.238-.341-.46-.784-.902l-.163-.163c-.291-.291-.437-.437-.583-.532a1.667 1.667 0 0 0-1.817 0c-.147.095-.292.24-.584.532-.095.096-.143.143-.198.183a.872.872 0 0 1-.719.122c-.065-.019-.117-.044-.221-.094a12.169 12.169 0 0 1-3.342-2.371Z"
    stroke="#12B75F"
    stroke-width="1.667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
